var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYellowCircleBlackExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#FFFF85"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9994 25.5237C21.2593 25.5237 25.5232 21.2597 25.5232 15.9999C25.5232 10.74 21.2593 6.47607 15.9994 6.47607C10.7395 6.47607 6.47559 10.74 6.47559 15.9999C6.47559 21.2597 10.7395 25.5237 15.9994 25.5237Z",
    stroke: "#2D2D2D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 19.8096H16.0095",
    stroke: "#2D2D2D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 12.1904V16",
    stroke: "#2D2D2D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowCircleBlackExclamation);
export default __webpack_public_path__ + "static/media/yellow-circle-black-exclamation.68aeb4602c434b4c811c488d03373f15.svg";
export { ForwardRef as ReactComponent };